export * from '../dist/vue-router.mjs'